function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSiteCoreAquaticSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 105,
    height: 105,
    viewBox: "0 0 27.78125 27.78125",
    id: "svg8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer2",
    style: {
      display: "inline"
    },
    transform: "translate(0,1.3229167)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#8abfec",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.28810185,
      strokeOpacity: 1
    },
    id: "rect4518-85-9",
    width: 27.78125,
    height: 27.78125,
    x: 0,
    y: -1.3229165
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#0073cf",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.2606636,
      strokeOpacity: 1
    },
    id: "rect4518-85-3",
    width: 25.135416,
    height: 25.135416,
    x: 1.3229166,
    y: -1.5894571e-7
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "#8abfec",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.20578703,
      strokeOpacity: 1
    },
    id: "rect4518-85",
    width: 19.84375,
    height: 19.84375,
    x: 3.96875,
    y: 2.6458333
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "#2e4762",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.17834875,
      strokeOpacity: 1
    },
    id: "rect4518-8-4",
    width: 17.197916,
    height: 17.197916,
    x: 5.2916665,
    y: 3.9687502
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#8abfec",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.24736783,
      strokeOpacity: 1
    },
    d: "m 16.867187,13.388583 c 0,1.738526 -1.332654,3.147875 -2.976562,3.147875 -1.643908,0 -2.976563,-1.409349 -2.976563,-3.147875 0,-1.738526 2.09198,-5.7818122 2.976563,-5.7818122 0.884583,0 2.976562,4.0432862 2.976562,5.7818122 z",
    id: "path4678-5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSiteCoreAquaticSelected);
export default __webpack_public_path__ + "static/media/icon-site-core-aquatic-selected.03485417ff95d863c7a078d79c6b96bb.svg";
export { ForwardRef as ReactComponent };